import dynamic from 'next/dynamic';

const Graph = dynamic(() => import('./Graphin'), {
    ssr: false,
});

export default Graph;
